export const siteSettings = {
  name: "Stream Finex",
  link: "https://streamfinex.net",
  email: "support@streamfinex.net",
  appLink: "https://app.streamfinex.net",
};
